import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/user-assignment/UserAssignmentAction";
import { getAuthorities, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { TeacherUsersFilter } from "./teacher-users-filter/TeacherUsersFilter";
import { TeacherUsersTable } from "./teacher-users-table/TeacherUsersTable";
import { useTeacherUsersUIContext } from "./TeacherUsersUIContext";

export function TeacherUsersCard({
  history,
  userGroupId,
  userType
}) {
  // Teacher Users Card UI Context
  const teacherUsersUIContext = useTeacherUsersUIContext();
  const teacherUsersUIProps = useMemo(() => {
    return {
      ids: teacherUsersUIContext.ids
    };
  }, [teacherUsersUIContext]);

  // Getting curret state of UserAssignment from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userAssignment }),
    shallowEqual
  );  
  const { authorities } = currentState;

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);

  // Teacher Users Redux state
  const dispatch = useDispatch();

  // Belli Bir Kullanıcı Grubuna Ait Kullanıcı Listesini Kaydeder
  const saveUsers = (ids) => {
    dispatch(actions.saveUsers(userType, userGroupId, ids)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/kullanici-ve-kullanici-gruplari/${userType}`), 2500);
  };

  const title = <>Öğretmen Kullanıcı Listesi{teacherUsersUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{teacherUsersUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title}>
        {
          isEditionAuthorized &&
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary ml-2"
              onClick={() => saveUsers(teacherUsersUIProps.ids)}
            >
              Kaydet
            </button>
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <TeacherUsersFilter />
        <TeacherUsersTable />
      </CardBody>
    </Card>
  );
}